/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bug': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M127.9 73.1a5 5 0 01-1.5 3.7c-1 1-2.2 1.6-3.6 1.6h-18c0 9.3-1.7 17.1-5.3 23.6l16.6 17a5 5 0 011.6 3.7 5 5 0 01-1.6 3.7c-1 1-2.1 1.5-3.6 1.5-1.4 0-2.6-.5-3.5-1.5l-15.9-16a15.5 15.5 0 01-1.2 1l-3.3 2.3a50.1 50.1 0 01-5.2 3 36.4 36.4 0 01-14.3 3.4v-73H59v73a32.2 32.2 0 01-15-3.8 66.8 66.8 0 01-5.3-3.2c-1.6-1-2.8-2-3.5-2.6l-1.2-1.2-14.6 17a5.1 5.1 0 01-7.3.4c-1-1-1.5-2.3-1.6-3.7 0-1.4.3-2.7 1.2-3.8l16.2-18.5C24.7 94.5 23 87 23 78.4H5.2c-1.3 0-2.5-.6-3.6-1.6S.1 74.5.1 73.1a5 5 0 011.5-3.6c1-1 2.3-1.6 3.6-1.6h18V44l-14-14a5 5 0 01-1.5-3.7 5 5 0 011.5-3.7c1-1 2.2-1.6 3.6-1.6s2.6.6 3.6 1.6l13.8 14.1h67.4l13.8-14.1a4.9 4.9 0 017.2 0 5 5 0 011.5 3.7 5 5 0 01-1.5 3.6L104.9 44v24h17.9c1.4 0 2.6.5 3.6 1.6a5 5 0 011.5 3.6zm-38.3-47H38.4C38.4 19 41 12.9 46 7.8 51 2.7 57 .1 64 .1s13.1 2.5 18 7.6c5 5 7.6 11.2 7.6 18.5z"/>'
  }
})
